




















	import {
		Instance
	} from '@/classes/TayehApi';
import { CreateDiscountBody, GetInstanceResponse } from '@/classes/TayehApi/Instance';
import {Component, Inject, Vue} from 'vue-property-decorator';
	@Component({})
	export default class ShopCreateCustomerForm extends Vue{
		@Inject() getInstance: () => GetInstanceResponse;
		form = new CreateDiscountBody();
		loading = false;
		
		async create() {
			this.loading = true;
			try {
				const res = await Instance.createDiscount(this.getInstance().id, this.form)
				if (res.data.err) {
					this.$message({
						showClose: true,
						message: res.data.err,
						type: 'error',
						duration: 5000
					})
				} else {
					if (typeof res.data.message == 'string')
					this.$message({
						showClose: true,
						message: res.data.message,
						type: 'success',
						duration: 5000
					})
					else
					this.$message({
						showClose: true,
						message: 'کد تخفیف با موفقیت ایجاد شد.',
						type: 'success',
						duration: 5000
					})
				}
				this.$emit('created');
			} finally {
				this.loading = false;
			}
			}
			reset() {
				this.form.code = '';
				this.form.remaining = 0;
			}
			handleChange(e: Event) {
				this.$emit('update')
		}
	}
